import * as types from "../../Action/actionTypes"

const initialState = {
  user: null,
  loading: false,
  error: null,
  initialized: false,
}

const getMeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ME_START:
      return { ...state, loading: true, error: null }
    case types.GET_ME_SUCCESS:
      return { ...state, loading: false, user: action.payload.user, error: null, initialized: true }
    case types.GET_ME_ERROR:
      return { ...state, loading: false, error: action.payload, initialized: true }
    case types.LOGIN_SUCCESS:
      return { ...state, loading: false, user: action.payload?.user ?? state.user, error: null, initialized: true }
    case types.SELECT_ROLE_SUCCESS:
      return { ...state, user: action.payload?.user ? { ...state.user, ...action.payload.user } : state.user }
    case types.UPDATE_KYC_STATUS: {
      if (!state.user) return state
      // Payload may be a plain status string (legacy) or
      // { status, kyc } object (post-submission with full doc details).
      const isObj = action.payload && typeof action.payload === 'object'
      return {
        ...state,
        user: {
          ...state.user,
          kyc_status: isObj ? action.payload.status : action.payload,
          ...(isObj && action.payload.kyc ? { kyc: action.payload.kyc } : {}),
        },
      }
    }
    case types.LOGOUT:
      return initialState
    default:
      return state
  }
}

export default getMeReducer
